import { Routes, Route } from "react-router-dom";
import FilteredNotesList from "components/Note/NoteListFollowup";
import { NotFoundScreen } from "screens/NotFoundScreen";

const NoteRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<FilteredNotesList source="Shipment"/>} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default NoteRouter;